export const PAGE_TYPE = {
  CONTRACT_PAGE: 'contractPage',
  WRITING_PAGE: 'writingPage',
  LIST_PAGE: 'listPage',
}
